import gql from 'graphql-tag';

export default gql`
query listFA_CustomerFormulareFacturaAdchnung($languageId: Int){
    fakturaAssist{
    listFA_CustomerFormulareFacturaAdchnung(languageId: $languageId){
		id
		name
    }
    
  }
}`;
